import React from 'react';

import './OpenedByColumn.scss';

export const OpenedByColumn = ({ value }: { value: 'yes' | 'no' }) => <div className={value === 'yes' ? 'audit-email-popup-opened-by-colum-wrapper' : ''}>
	{value}
</div>;
